import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  putProjectsProjectIDJobsJobIDAnswers,
  type SaveJobAnswersRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PROJECTS_QUERY_KEYS } from "Projects/Api/Queries/queryKeys";

export function useSaveJobAnswersMutation(projectID: string, jobID: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse((request: SaveJobAnswersRequest) =>
      putProjectsProjectIDJobsJobIDAnswers(request, projectID, jobID),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.jobDetail(projectID, jobID),
      });
    },
  });
}
